import { loadSnowplow } from '@pocket/web-utilities/analytics'
import {
  SNOWPLOW_COLLECTOR,
  SNOWPLOW_HEARTBEAT_DELAY,
  SNOWPLOW_HEARTBEAT_INTERVAL,
  SNOWPLOW_CONFIG
} from 'common/constants'
import { internalDomains } from 'common/constants'
import {
  CONTENT_OPEN_DESTINATION_INTERNAL,
  CONTENT_OPEN_DESTINATION_EXTERNAL
} from 'common/snowplow/events'

export function initializeSnowplow() {
  loadSnowplow('snowplow')
  // configure snowplow
  snowplow('newTracker', 'sp', SNOWPLOW_COLLECTOR, SNOWPLOW_CONFIG)
  // enable activity monitoring (heartbeat)
  snowplow(
    'enableActivityTracking',
    SNOWPLOW_HEARTBEAT_DELAY,
    SNOWPLOW_HEARTBEAT_INTERVAL
  )
  // automatic link tracking
  snowplow('enableLinkClickTracking')
  // automatic form elements tracking
  snowplow('enableFormTracking')
}

export const getLinkOpenTarget = (link, isSyndicated = false) => {
  const url = new URL(link)

  if (isSyndicated) return CONTENT_OPEN_DESTINATION_INTERNAL

  if (internalDomains.includes(url.hostname))
    return CONTENT_OPEN_DESTINATION_INTERNAL

  return CONTENT_OPEN_DESTINATION_EXTERNAL
}
